import { pickAll } from 'ramda'
import { useParams } from 'react-router-dom'

import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'
import { useOrg } from '@/hooks'
import useValidateEndpoint from '@/hooks/useValidate'
import { ConfigDataScreen } from '@/screens/ComponentLibrary/components'
import { useGetCustomComponent } from '@/screens/ComponentLibrary/hooks'
import { parseComponentTypes, renameKeys, splitAndTrim } from '@/utils'
import { ComponentType } from '@/utils/api'

import { UserGroupingSettings } from './Settings'

export type parseUserGroupingParam =
  | { settings: UserGroupingSettings }
  | string
  | null
  | undefined

export const parseUserGroupingData = (
  orgSlug?: string,
  param?: parseUserGroupingParam
) => {
  if (!orgSlug || !param) return {}
  const data = parseComponentTypes(param, ComponentType.userGrouping)

  if (!data) return {}
  const safeSettings = pickAll(
    ['groupingQuestionText', 'buttons'],
    data.settings
  )

  if (!data) return {}
  return {
    data: renameKeys(
      { groupingQuestionText: 'GroupingQuestionText' },
      {
        GroupingButtons: safeSettings.buttons.map((e) => ({
          label: { en: e.question },
          value: e.name,
        })),
        groupingQuestionText: {
          en: splitAndTrim('\n')(safeSettings.groupingQuestionText),
        },
      }
    ),
    organization: orgSlug,
    schemaName: 'BasicUserGroupingConfig',
    schemaVersion: '1.0.0',
    version: '1.0.0',
  }
}

export const useParseUserGroupingData = (
  orgSlug?: string,
  param?: parseUserGroupingParam
) => parseUserGroupingData(orgSlug, param)

export const ConfigData = () => {
  const { orgID } = useParams()
  const { componentID } = useComponentProvider()
  const org = useOrg(orgID)
  const current = useGetCustomComponent<UserGroupingSettings>(componentID)
  const config = useParseUserGroupingData(org.data?.slug, current.data)
  const valid = useValidateEndpoint(config, componentID)
  return (
    <ConfigDataScreen
      config={config}
      current={current}
      org={org}
      rootName="User grouping"
      valid={valid}
    />
  )
}
